import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { FormGroup } from "@mui/material";
const EzFormGroupMui = forwardRef(
  ({ ariaLabel, children, gap, labelWidth, row, ...props }, ref) => {
    return /* @__PURE__ */ jsx(
      FormGroup,
      {
        ref,
        "aria-label": ariaLabel,
        classes: {
          root: "EzFormGroup"
        },
        row,
        sx: {
          display: "flex",
          gap: gap ?? (row ? 2 : 0),
          ".EzSuperFormControlLabel": {
            width: labelWidth ? `${labelWidth}px` : "auto"
          }
        },
        ...props,
        children
      }
    );
  }
);
EzFormGroupMui.displayName = "EzFormGroupMui";
export {
  EzFormGroupMui as default
};
//# sourceMappingURL=EzFormGroupMui.es.js.map
